import dashboard from 'assets/images/Dashboard.svg';
import dashboardBlue from 'assets/images/DashboardBlue.svg';
import LiveTracking from 'assets/images/LiveTracking.svg';
import LiveTrackingBlue from 'assets/images/LiveTrackingBlue.svg';
import vendor from 'assets/images/Vendor.svg';
import vendorBlue from 'assets/images/VendorBlue.svg';
import customer from 'assets/images/Customer.svg';
import customerBlue from 'assets/images/CustomerBlue.svg';
import driver from 'assets/images/Driver.svg';
import driverBlue from 'assets/images/DriverBlue.svg';
import rideTrack from 'assets/images/RideTrack.svg';
import rideTrackBlue from 'assets/images/RideTrackBlue.svg';
import support from 'assets/images/Support.svg';
import supportBlue from 'assets/images/SupportBlue.svg';
import compliance from 'assets/images/Compliance.svg';
import complianceBlue from 'assets/images/ComplianceBlue.svg';
import feedback from 'assets/images/Feedback.svg';
import feedbackBlue from 'assets/images/FeedbackBlue.svg';
import invoice from 'assets/images/Invoice.svg';
import invoiceBlue from 'assets/images/InvoiceBlue.svg';
import notification from 'assets/images/Notification.svg';
import notificationBlue from 'assets/images/NotificationBlue.svg';
import report from 'assets/images/Report.svg';
import reportBlue from 'assets/images/ReportBlue.svg';
import setting from 'assets/images/Setting.svg';
import settingBlue from 'assets/images/SettingBlue.svg';
import configuration from 'assets/images/Configure.svg';
import logout from 'assets/images/Logout.svg';
import logoutBlue from 'assets/images/LogoutBlue.svg';
import RateCard from 'assets/images/RateCard.svg';
import RateCardBlue from 'assets/images/RateCardBlue.svg';
import FAQ from 'assets/images/FAQ.svg';
import FAQBlue from 'assets/images/FAQBlue.svg';
import ComplianceConfig from 'assets/images/ComplianceConfig.svg';
import ComplianceConfigBlue from 'assets/images/ComplianceConfigBlue.svg';
import ConfigVehicle from 'assets/images/ConfigVehicle.svg';
import ConfigVehicleBlue from 'assets/images/ConfigVehicleBlue.svg';
import FeebackConfig from 'assets/images/FeedbackConfig.svg';
import FeebackConfigBlue from 'assets/images/FeedbackConfigBlue.svg';
import Booking from "assets/images/Booking Inactive.svg"
import BookingBlue from "assets/images/Booking Active.svg";
import couponBlue from "assets/images/couponBlue.svg";
import reportCustomer from "assets/images/reportCustomer.svg"
import activeReportCustomer from "assets/images/activeReportCustomer.svg"
import revenue from "assets/images/revenue.svg"
import activeRevenue from "assets/images/activeRevenue.svg"
import coupon from 'assets/images/Coupon Inactive.svg'
import CouponWhite from 'assets/images/CouponWhite.svg';
import complaintBlue from '../../assets/images/complaintBlue.svg';
import complaint from '../../assets/images/complaint.svg';
import TollCharge from 'assets/images/TollCharge.svg';
import TollChargeBlue from 'assets/images/TollChargeBlue.svg';
import RideTrackBlack from 'assets/images/RideTrackBlack.svg';
import reportInActive from 'assets/images/reportInActive.svg';
import reportActive from 'assets/images/reportActive.svg';
import systemSettings from '../../assets/images/systemSettings.svg';
import systemSettingsBlue from '../../assets/images/systemSettingsBlue.svg';
import settingWhite from '../../assets/images/settingWhite.svg';
import Reservation from 'assets/images/Reservation.svg';
import ReservationBlue from 'assets/images/ReservationBlue.svg';
import assignTripInactive from 'assets/images/assignTripInactive.svg';
import assignTripBlue from 'assets/images/assignTripBlue.svg';
import assignVehcileInactive from 'assets/images/assignVehicleInactive.svg';
import assignVehcileBlue from 'assets/images/assignVehicleBlue.svg';
import assignDriverInactive from 'assets/images/assignDriverInactive.svg';
import assignDriverBlue from 'assets/images/assignDriverBlue.svg';
import serviceableZoneIcon from 'assets/images/smLocationIcon.svg';
import serviceableZoneIconActive from 'assets/images/serviceableZoneBlue.svg';

export const sideNavData = [
  {
    id: 0,
    field: 'Dashboard',
    path: 'dashboard',
    keyword: "dashboard",
    icon: dashboard,
    activeIcon: dashboardBlue,
  },
  {
    id: 1,
    field: 'Live tracking',
    path: 'liveTracking',
    keyword: "liveTracking",
    icon: LiveTracking,
    activeIcon: LiveTrackingBlue,
  },
  {
    id: 2,
    field: 'City Manager',
    keyword: "cityManager",
    path: 'vendor',
    icon: vendor,
    activeIcon: vendorBlue,
  },
  {
  id: 3,
   field: 'Tickets',
   path: 'complaints',
   keyword: "complaints",
   icon: complaint,
   activeIcon: complaintBlue,
 },
 {
  id: 4,
   field: 'Promotion',
   path: 'promotions',
   keyword: "complaints",
   icon: CouponWhite,
   activeIcon: couponBlue,
 },
  {
  id: 4,
   field: 'Reservation',
   path: 'reservation',
   keyword: "complaints",
   icon: Reservation,
   activeIcon: ReservationBlue,
 },
  {
    id: 5,
    field: 'Customers',
    path: 'customer',
    keyword: "customer",
    icon: customer,
    activeIcon: customerBlue,
  },
  {
    id: 6,
    field: 'Assign',
    path: '',
    keyword: "assign",
    icon: vendor,
    activeIcon: vendorBlue,
    submenu: [
      {
        id: 17,
        subIndex: "assignConfiguration",
        field: 'Assign Trip',
        keyword: "assignTrip",
        path: 'assignTrip',
        icon: assignTripInactive,
        activeIcon: assignTripBlue,
      },
      {
        id: 18,
        subIndex: "assignConfiguration",
        field: 'Assign Vehicle',
        keyword: "assignVehicle",
        path: 'assignVehicle',
        icon: assignVehcileInactive,
        activeIcon: assignVehcileBlue,
      },
      {
        id: 19,
        subIndex: "assignConfiguration",
        field: 'Assign Driver',
        keyword: "assignDriver",
        path: 'assignDriver',
        icon: assignDriverInactive,
        activeIcon: assignDriverBlue,
      },
    ],
  },
  {
    id: 7,
    field: 'Sub-Vendor',
    path: 'subvendor',
    keyword: "subVendors",
    icon: customer,
    activeIcon: customerBlue,
  },
  {
    id: 8,
    field: 'Own Drivers',
    path: 'driver',
    keyword: "ownDrivers",
    icon: driver,
    activeIcon: driverBlue,
  },
  {
    id: 9,
    field: 'Vehicle',
    path: 'Vehicle',
    keyword: "vehicle",
    icon: driver,
    activeIcon: driverBlue,
  },
  {
    id: 10,
    field: 'Track Trip',
    path: 'rideTrack',
    keyword: "trackTrip",
    icon: rideTrack,
    activeIcon: rideTrackBlue,
  },
  {
    id: 11,
    field: 'Support console',
    path: 'support',
    keyword: "supportConsole",
    icon: support,
    activeIcon: supportBlue,
  },
  {
    id: 12,
    field: 'Compliance',
    path: 'compliance',
    keyword: "compliance",
    icon: compliance,
    activeIcon: complianceBlue,
  },
  {
    id: 13,
    field: 'Feedback',
    path: 'feedback',
    keyword: "feedback",
    icon: feedback,
    activeIcon: feedbackBlue,
  },
  {
    id: 14,
    field: 'Reports',
    path: 'reports',
    keyword: "reports",
    icon: report,
    activeIcon: reportBlue,

    submenu: [
      {
        id: 42,
        field: "Revenue",
        path: "reports-revenue",
        icon: revenue,
        activeIcon: activeRevenue,
      },
      {
        id: 20,
        subIndex: "reportsSubMenu",
        field: "Booking",
        path: "booking",
        keyword: "booking",
        icon: Booking,
        activeIcon: BookingBlue,
      },
      {
        id: 21,
        subIndex: "reportsSubMenu",
        field: "Coupon",
        path: "coupon-report",
        keyword: "coupon",
        icon: coupon,
        activeIcon: couponBlue,
      },
      {
        id: 22,
        subIndex: "reportsSubMenu",
        field: "Trip Details",
        path: "trip-details-report",
        keyword: "booking",
        icon: RideTrackBlack,
        activeIcon: rideTrackBlue,
      },
      {
        id: 23,
        subIndex: "reportsSubMenu",
        field: "Generated Reports",
        path: "report-generate",
        keyword: "coupon",
        icon: reportInActive,
        activeIcon: reportActive,
      }
    ]
  },
  {
    id: 15,
    field: 'Configuration',
    path: 'configuration',
    keyword: "configuration",
    icon: configuration,
    activeIcon: complianceBlue,
    submenu: [
      //     {
      //   id:21,
      //   subIndex: "configurationSubMenu",
      //   field:"Rate Card",
      //   path:"ratecard",
      //   keyword: "rateCard",
      //   icon: RateCard,
      //   activeIcon: RateCardBlue,
      // },
      {
        id:22,
        subIndex: "configurationSubMenu",
        field:"Rate Card",
        path:"ratecard",
        keyword: "rateCard",
        icon: RateCard,
        activeIcon: RateCardBlue,
      },
      
      {
        id:23,
        subIndex: "configurationSubMenu",
        field:"Toll Management",
        path:"tollCharges",
        keyword: "tollCharges",
        icon: TollCharge,
        activeIcon: TollChargeBlue,
      },
      {
        id: 30,
        subIndex: "configurationSubMenu",
        field: "Serviceable Zones",
        path: "serviceableZones",
        keyword: "serviceableZones",
        icon: serviceableZoneIcon,
        activeIcon: serviceableZoneIconActive,
      },
      {
        id: 24,
        subIndex: "configurationSubMenu",
        field: 'Compliance',
        path: 'addcomplaince',
        keyword: "compliance",
        icon: ComplianceConfig,
        activeIcon: ComplianceConfigBlue,
      },
      {
        id: 25,
        subIndex: "configurationSubMenu",
        field: 'Feedback',
        path: 'addfeedback',
        keyword: "feedback",
        icon: FeebackConfig,
        activeIcon: FeebackConfigBlue,
      },
      {
        id: 26,
        subIndex: "configurationSubMenu",
        field: 'Vehicle Category',
        path: 'addcabcategory',
        keyword: "vehicleCategory",
        icon: ConfigVehicle,
        activeIcon: ConfigVehicleBlue,
      },
      {
        id: 27,
        subIndex: "configurationSubMenu",
        field: 'FAQs',
        path: 'faq/Customer',
        keyword: "faq",
        icon: FAQ,
        activeIcon: FAQBlue,
      },
      // {
      //   id: 28,
      //   subIndex: "configurationSubMenu",
      //   field: 'coupon',
      //   path: 'coupon',
      //   keyword: "coupon",
      //   icon: coupon,
      //   activeIcon: couponBlue,
      // },
    ],
  },
  {
    id: 16,
    field: 'Invoice',
    path: 'invoice',
    keyword: 'invoice',
    icon: invoice,
    activeIcon: invoiceBlue,
  },
  {
    id: 17,
    field: 'Notification',
    path: 'notification',
    keyword: 'notification',
    icon: notification,
    activeIcon: notificationBlue,
  },
];

export const commonSideData = [
  {
    id: 17,
    field: 'Settings',
    path: 'settings',
    keyword: "settings",
    icon: settingWhite,
    activeIcon: settingBlue,
    submenu: [
      {
        id: 28,
        field: 'Account Settings',
        path: 'account',
        keyword: "settings",
        icon: setting,
        activeIcon: settingBlue,
      },
      {
        id: 29,
        field: 'System Settings',
        path: 'adminSetting',
        icon: systemSettings,
        activeIcon: systemSettingsBlue,
      },
    ],
  },
  {
    id: 18,
    field: 'Logout',
    path: '',
    icon: logout,
    activeIcon: logoutBlue,
  },
];

